// Zentrale ICE-Server-Konfiguration für ALLE WebRTC-Transports (Moderator + Schüler).
// Lädt kurzlebige TURN-Credentials vom Backend und cached sie bis kurz vor Ablauf.
// Fällt bei Nichterreichbarkeit auf reines STUN zurück (kein harter Fehler).

const STUN_FALLBACK = [
  { urls: 'stun:stun.l.google.com:19302' },
  { urls: 'stun:stun1.l.google.com:19302' },
];

// Konsistent mit App.js/ModView.js: REACT_APP_BACKEND_URL enthält bereits /api.
const BACKEND_BASE = process.env.REACT_APP_BACKEND_URL || 'https://rooms.okadia.de/api';

let cached = null; // { iceServers: [...], expiresAt: number }
let pendingFetch = null;

/**
 * Liefert die ICE-Server inkl. TURN. authToken = das JWT der laufenden Session.
 * @param {string} authToken
 * @returns {Promise<RTCIceServer[]>}
 */
export async function getIceServers(authToken) {
  const now = Date.now();
  if (cached && cached.expiresAt - now > 60_000) {
    return cached.iceServers;
  }
  if (pendingFetch) return pendingFetch;
  pendingFetch = (async () => {
    try {
      const res = await fetch(`${BACKEND_BASE}/turn-credentials`, {
        headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
      });
      if (!res.ok) throw new Error(`TURN-Credentials HTTP ${res.status}`);
      const data = await res.json(); // { username, credential, ttl, urls: [...] }
      if (!data.urls || !data.username || !data.credential) throw new Error('Ungültige TURN-Antwort vom Backend');
      const iceServers = [
        ...STUN_FALLBACK,
        { urls: data.urls, username: data.username, credential: data.credential },
      ];
      cached = { iceServers, expiresAt: now + (data.ttl || 3600) * 1000 };
      console.log('🧊 ICE-Server inkl. TURN geladen:', data.urls);
      return iceServers;
    } catch (e) {
      console.warn('⚠️ TURN-Credentials nicht erreichbar, nutze nur STUN:', e.message);
      return STUN_FALLBACK;
    }
  })().finally(() => { pendingFetch = null; });
  return pendingFetch;
}
